<template>
  <div class="platform-upload-wrap">
    <UploadModeNav v-model="platform" :originate-client="originateClient" style="margin-bottom: 20px" />
    <div
      :class="[`upload-form-for-${platform}`]"
      class="upload-form"
    >
      <div class="l" :class="platform === 'mobile' && 'lm'">
        <div class="item">
          <label class="select">
            <em class="hl">*</em>上传手机主题：
            <div v-if="!uploadDisable" class="input-select select-image">
              <span>选择文件</span>
              <div class="dropdown">
                <ul>
                  <li v-if="platform === 'all' || platform === 'pc'" @click="handleSelectPcVideo">上传电脑版</li>
                  <li v-if="platform === 'all' || platform === 'mobile'" @click="handleSelectMobileVideo">上传手机版</li>
                </ul>
              </div>
            </div>
            <span v-if="subWtype === 2 && platform !== 'mobile'" class="is-theme">该壁纸包含主题组件</span>
          </label>
          <div class="flex upload-area">
            <UploadVideo
              v-if="platform === 'pc' || platform === 'all'"
              ref="uploadPc"
              :disable="uploadDisable"
              platform="pc"
              :size="200 * 1024 * 1024"
              :originate-client="originateClient"
              :pre-resource-id="form.resource_id"
              :pre-resource-url="form.paper_url"
              :pre-preview-url="form.preview_jpg"
              @change="onPcWallpaperDataUpdate"
              @error="handleError"
            />
            <UploadVideo
              v-if="platform === 'mobile' || platform === 'all'"
              ref="uploadMobile"
              :disable="uploadDisable"
              platform="mobile"
              :originate-client="originateClient"
              :pre-resource-id="form.mobile_resource_id"
              :pre-resource-url="form.mobile_paper_url"
              :pre-preview-url="form.mobile_preview_jpg"
              :width="platform === 'mobile' ? 314 : 158"
              :height="platform === 'mobile' ? 558 : 280"
              :video-width="1080"
              :video-height="1920"
              :size="100 * 1024 * 1024"
              :style="platform === 'all' && 'margin-left: 20px'"
              @change="onMobileWallpaperDataUpdate"
              @error="handleError"
            />
          </div>
        </div>
        <div class="item" style="width: 20px" />
        <!-- <div class="item">
          <label class="select">
            上传预览封面：
            <div class="input-select select-image">
              <span>选择文件</span>
              <div class="dropdown">
                <ul>
                  <li v-if="platform === 'all' || platform === 'pc'" @click="handleSelectPcPoster">上传电脑版</li>
                  <li v-if="platform === 'all' || platform === 'mobile'" @click="handleSelectMobilePoster">上传手机版</li>
                </ul>
              </div>
            </div>
          </label>
          <div class="flex upload-area">
            <UploadPreview
              v-if="platform === 'pc' || platform === 'all'"
              ref="previewPc"
              :preview-url="form.preview_jpg"
              @error="handleError"
              @upload="handlePreviewUpload"
            />
            <UploadPreview
              v-if="platform === 'mobile' || platform === 'all'"
              ref="previewMobile"
              :preview-url="form.mobile_preview_jpg"
              text="手机版预览图"
              platform="mobile"
              :width="platform === 'mobile' ? 314 : 87"
              :height="platform === 'mobile'? 558 : 154"
              :preview-width="320"
              :preview-height="568"
              :size="1 * 1024 * 1024"
              :style="platform === 'all' && 'margin-left: 10px'"
              @error="handleError"
              @upload="handlePreviewUpload"
            />
          </div>
        </div> -->
      </div>
      <div class="r">
        <div class="row">
          <label>
            <em class="hl">*</em>主题名称：
          </label>
          <div class="s">
            <el-input
              v-model="form.wname"
              clearable
              placeholder="合适的名字能让人一见钟情哦"
            />
            <span
              v-if="form.wname && form.wname.length > maxTextLength"
              class="error"
            >壁纸名称最多支持{{ maxTextLength }}个字哦</span>
          </div>
        </div>
        <div class="row">
          <label>
            <em class="hl">*</em>分类：
          </label>
          <div class="s">
            <el-select
              v-model="form.cid"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <!-- <div class="row one-row">
          <label>
            <em class="hl">*</em>标签：
          </label>
          <div class="s">
            <el-select
              v-model="tagsInput"
              :remote-method="fetchFindTagList"
              allow-create
              default-first-option
              filterable
              multiple
              placeholder="请选择或编辑后按回车键录入"
              remote
            >
              <el-option
                v-for="item in filteredTagList"
                :key="item.id"
                :label="item.tname"
                :value="item.tname"
              />
            </el-select>
            <span v-if="tagsInput.length < 3" class="tag-tips">至少添加3个标签</span>
            <span v-if="hasTagLengthExceedsLimit" class="error">标签最多支持{{ maxTextLength }}个字哦</span>
          </div>
        </div> -->
        <!-- <div v-if="userInfoFresh.user_type === 0" class="row">
          <label>
            <em class="hl">*</em>联系方式：
          </label>
          <div class="s">
            <el-input
              v-model="form.contract"
              clearable
              placeholder="请输入QQ账号/邮箱/手机号码"
            />
          </div>
        </div> -->
        <!-- <div v-if="ckey.reference.length + (ckey.categories[form.cid] ? ckey.categories[form.cid].length : 0) > 0" class="row one-row">
          <p class="tags-label">参考标签：</p>
          <div class="tags">
            <button v-for="tag in ckey.reference" :key="tag.tag" :class="['tips-tag', tag.state && 'active']" round @click="clickTipsTag(tag)">{{ tag.tag }}</button>
            <br>
            <button v-for="tag in ckey.categories[form.cid]" :key="tag.tag" :class="['tips-tag', tag.state && 'active']" round @click="clickTipsTag(tag)">{{ tag.tag }}</button>
          </div>
        </div> -->
        <div v-if="ckey.contest.length > 0" class="row one-row">
          <p class="tags-label">
            参与活动：
          </p>
          <div class="tags">
            <button v-for="tag in ckey.contest" :key="tag.tag" class="tips-tag" :class="[tag.state && 'active']" round @click="clickTipsTag(tag)">
              {{ tag.tag }}
            </button>
          </div>
        </div>
        <div class="row one-row">
          <!-- 赞赏类型 -->
          <label>
            <em class="hl">*</em>赞赏类型（下载量达标且认证成为元气UP后，可获得壁纸的赞赏收益）：
            <p
              v-if="userInfoFresh.user_type >= 1"
              class="yuanbao-tips"
              @click="showYuanbao = true"
            >
              <i class="icon-qa">?</i>
              赞赏壁纸元宝分成说明
            </p>
          </label>
          <div class="s">
            <el-radio v-model="form.ptype" :label="1">
              会员赞赏
            </el-radio>
            <el-tooltip class="item" effect="dark" content="仅手机壁纸支持广告赞赏" placement="top-start">
              <el-radio v-model="form.ptype" :label="2">
                广告赞赏
              </el-radio>
            </el-tooltip>
            <el-radio v-model="form.ptype" :label="0">
              无需赞赏
            </el-radio>
          </div>
          <!-- <div v-if="form.ptype === 1" class="row">
            <label>
              <em class="hl">*</em>赞赏金额（单位：鱼干）
            </label>
            <div class="s">
              <el-select
                v-model="form.price"
                placeholder="请选择价格"
              >
                <el-option
                  v-for="price in priceList"
                  :key="price"
                  :label="price / 100"
                  :value="+price"
                />
              </el-select>
            </div>
          </div> -->
        </div>
        <div class="ctrl one-row">
          <div class="confirm">
            <el-checkbox v-model="treatyChecked">
              我已阅读并同意
            </el-checkbox>
            <a
              href="http://mobile-wallpaper-cdn.zhhainiao.com/mobile/agreement/yuanqiwallpaper-upload-cn.html"
              rel="noopener noreferrer"
              target="_blank"
            >《壁纸上传发布服务使用协议》</a>
          </div>
          <span class="btn-publish" @click="fetchPublish">发布</span>
        </div>
      </div>
    </div>
    <div
      v-if="confirmDialogText"
      class="confirm-dalog-wrap"
    >
      <ConfirmDialog
        :text="confirmDialogText"
        @close="handleConfirmDialogClose"
      />
    </div>
    <!-- 错误提示和警告提示框 -->
    <div v-if="confirmDialogText" class="confirm-dalog-wrap">
      <ConfirmDialog
        :confirm-text="confirmDialogConfirmText"
        :text="confirmDialogText"
        @close="handleConfirmDialogClose"
        @confirm="handleConfirmDialogConfirm"
      />
    </div>
    <div v-if="confirmDialogText || showYuanbao || showUpAuthDialog" class="mask" />
    <div v-if="showYuanbao" class="rule-wrap">
      <YuanbaoAuthorRule @close="showYuanbao = false" />
    </div>
    <UpAuthDialog v-model="showUpAuthDialog" class="rule-wrap" is-confirm :now-downloads="userInfoFresh.works_download_cnt + userInfoFresh.works_mobile_download_cnt" />
    <!-- 签约成功后不再弹窗 -->
    <!-- <div v-if="showHezuo" class="rule-wrap">
      <HezuoAuthorRule :url="contractCheck.url" :status="contractCheck.status" @close="showHezuo = false" />
    </div>
    <div v-if="contractCheckWarn" class="rule-wrap">
      <HezuoWarn @close="contractCheckWarn = false" />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EventEmit from '@/utils/EventEmit'

import ConfirmDialog from '@/components/dialog/ConfirmDialog'
import UploadModeNav from '@/components/Upload/UploadModeNav.vue'
import UploadVideo from '@/components/Upload/UploadVideo.vue'
// import UploadPreview from '@/components/Upload/UploadPreview.vue'
import YuanbaoAuthorRule from '@/components/dialog/YuanbaoAuthorRule'
import UpAuthDialog from '@/components/dialog/upAuthDialog'
import { fetchCkey } from '@/api/config'
import { fetchUserInfo } from '@/api/user'

import {
  doCommit,
  findTagList,
  getComponentList,
} from '@/api/upload'

const initialForm = {
  // cid: 0,
  tags: '',
  wname: '',
  contract: '',
  resource_id: undefined,
  previewPcUserUpload: false,
  previewMobileUserUpload: false,
  ptype: 0, // 付费类型，0：免费，1：付费
  wtype: 5, // 0：动态壁纸 ， 1：场景壁纸，2: 静态壁纸 5: 手机主题壁纸
  paper_url: '',
  preview_jpg: '',
  mobile_resource_id: undefined,
  mobile_wtype: 3, // 3：动态壁纸 (移动端)， 4: 静态壁纸(移动端)
  mobile_paper_url: '',
  mobile_preview_jpg: '',
  resource_format: 'mp4',
  mobile_resource_format: 'zip',
  // cooperate_type: 1, // 合作方式
  auth_amount: undefined, // 授权金额
  mobile_clip_area: '', // 移动端壁纸裁剪区域（场景壁纸生成手机动态壁纸裁剪区域）
  vip_effect_ids: '', // 英文逗号分隔的特效id
  sub_wtype: 1, // 1代表普通壁纸，2代表主题壁纸
}

export default {
  name: 'ThemeUpload',
  components: {
    ConfirmDialog,
    UploadModeNav,
    UploadVideo,
    // UploadPreview,
    YuanbaoAuthorRule,
    UpAuthDialog,
    // HezuoAuthorRule,
    // HezuoWarn
  },
  props: {
    subWtype: {
      type: Number,
      default: 1,
    },
    queryPlatform: {
      type: String,
      default: 'pc',
    },
    previewJPGMobile: {
      type: String,
      default: '',
    },
    mobileCrop: {
      type: String,
      default: '',
    },
    resourceId: {
      type: String,
      default: '',
    },
    resourceUrl: {
      type: String,
      default: '',
    },
    previewJpg: {
      type: String,
      default: '',
    },
    effectId: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      originateClient: false,
      platform: this.queryPlatform,
      fileMaxSize: 10 * 1024 * 1024, // 10M
      form: Object.assign({}, initialForm),
      maxTextLength: 15,
      confirmDialogText: '',
      treatyChecked: false,
      cateList: [],
      tagList: [],
      userInfoFresh: {},
      confirmDialogConfirmText: '我知道了',
      showYuanbao: false,
      // showHezuo: false,
      priceList: [6000, 9000, 11000, 12000, 14000, 16000, 18000, 20000, 22000, 24000, 29000, 32000, 36000, 39000],
      contractCheckWarn: false,
      contractCheck: {}, // 签约状态
      isContractCheck: false, // 签约成功
      uploadDisable: false, // 阻止修改上传内容
      showUpAuthDialog: false,
      ckey: {
        reference: [],
        categories: [],
        contest: [],
        tagMap: new Map(),
      },
      checkedTagEl: new Map(), // 选中的标签元素
      // preview_jpg: '',
      // mobile_preview_jpg: ''
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
      contestConfig: state => state.contestConfig,
    }),
    /**
     * 标签列表 - 用于标签输入组件
    */
    tagsInput: {
      /** @returns {string[]} */
      get() {
        return this.form.tags ? this.form.tags.split(',') : []
      },
      set(list) {
        const oldList = this.form.tags.split(',')
        for (const oldTag of oldList) {
          if (!list.includes(oldTag)) { // 旧有新无
            const target = this.checkedTagEl.get(oldTag)
            if (target) {
              target.state = !target.state
              this.checkedTagEl.delete(oldTag)
            }
            break
          }
        }
        for (const newTag of list) {
          if (!oldList.includes(newTag)) { // 旧无新有
            if (this.ckey.tagMap.has(newTag)) {
              this.ckey.tagMap.get(newTag).state = true
            }
            break
          }
        }
        this.form.tags = list.join(',')
      },
    },
    /** 是否有单个标签长度超出限制 */
    hasTagLengthExceedsLimit() {
      return this.tagsInput.some(tag => tag.length > this.maxTextLength)
    },
    filteredTagList() {
      console.log('tagList', this.tagList)
      if (this.contestConfig && this.contestConfig.contest_tag_name && this.contestConfig.period !== 4) {
        return this.tagList.filter(tag => tag.tname !== this.contestConfig.contest_tag_name)
      }
      return this.tagList
    },
    canJoinContest() {
      const { contestConfig, platform } = this
      console.log('canJoinContest', contestConfig, platform)
      return this.userInfoFresh.user_type >= 3 && contestConfig
        && (contestConfig.platform === platform || platform === 'all' || contestConfig.platform === 'all')
    },
  },
  watch: {
    platform() {
      this.initForm()
    },
  },
  mounted() {
    this.fetchCateList()
    this.fetchFindTagList()
    this.fetchUserInfo()
    this.fetchCurrentContestConfig()
    this.fetchContractCheck()
    this.fetchClientParams()
    this.fetchCkey()
  },
  methods: {
    ...mapActions(['fetchCurrentContestConfig']),
    handlePreviewUpload({ url, platform }) {
      if (platform === 'mobile') {
        // this.mobile_preview_jpg = url
        this.form.mobile_preview_jpg = url
        this.previewMobileUserUpload = true
      } else {
        // this.preview_jpg = url
        this.form.preview_jpg = url
        this.previewPcUserUpload = true
      }
    },
    initForm() {
      this.form = Object.assign({}, initialForm)
      this.$refs.uploadPc && this.$refs.uploadPc.handleRemoveVideoResource()
      this.$refs.uploadMobile && this.$refs.uploadMobile.handleRemoveVideoResource()
    },
    handleError(tips) {
      this.confirmDialogText = tips
    },
    handleSelectPcVideo() {
      this.$refs.uploadPc.handleSelectUpload()
    },
    handleSelectMobileVideo() {
      this.$refs.uploadMobile.handleSelectUpload()
    },
    handleSelectPcPoster() {
      this.$refs.previewPc.handleSelectPoster()
    },
    handleSelectMobilePoster() {
      this.$refs.previewMobile.handleSelectPoster()
    },
    onPcWallpaperDataUpdate(data) {
      console.log('pc video:', data)
      this.form.paper_url = data.resourceUrl
      this.form.resource_id = data.resourceId
      if (!this.previewPcUserUpload) {
        this.form.preview_jpg = data.preview
      }
      this.$forceUpdate()
    },
    clickTipsTag(tag) {
      const HAS_KEY = new RegExp(`(,?)(${tag.tag})(,?)`)
      tag.state = !tag.state
      const isAdd = tag.state
      const isHadKey = HAS_KEY.test(this.form.tags)
      if (isAdd && !isHadKey) {
        this.form.tags += (this.form.tags.length > 0 ? ',' : '') + tag.tag
        this.checkedTagEl.set(tag.tag, tag)
      } else if (!isAdd && isHadKey) {
        this.checkedTagEl.delete(tag.tag)

        this.form.tags = this.form.tags.replace(HAS_KEY, (s, s1, s2, s3) => {
          return s1 === ',' && s3 === ',' ? ',' : ''
        })
      }
      console.log('clickTipstag', this.form.tags)
    },
    onMobileWallpaperDataUpdate(data) {
      console.log('mobile video:', data)
      this.form.mobile_paper_url = data.resourceUrl
      this.form.mobile_resource_id = data.resourceId
      if (!this.previewMobileUserUpload) {
        this.form.mobile_preview_jpg = data.preview
      }
      this.$forceUpdate()
    },
    verification() {
      if (!this.userInfo.token) {
        EventEmit.$emit('SHOW_LOGIN_DIALOG')
        return false
      }

      if (!this.treatyChecked) {
        this.confirmDialogText = '请阅读并同意用户上传协议'
        return false
      }

      const { platform, form } = this

      // // 只有这两种才能输入金额，普通授权是不需要输入金额的，这时文本框都要隐藏掉， 请求api的时候报0
      // if (form.cooperate_type !== 1 && (form.auth_amount < 1 || form.auth_amount > 1000)) {
      //   this.confirmDialogText = '授权金额填写范围0-1000'
      //   return false
      // }

      if ((platform === 'all' || platform === 'pc') && !form.paper_url) {
        this.confirmDialogText = '请上传电脑动态壁纸'
        return false
      }

      if ((platform === 'all' || platform === 'mobile') && !form.mobile_paper_url) {
        this.confirmDialogText = '请上传移动动态壁纸'
        return false
      }

      if (!form.wname) {
        this.confirmDialogText = '请输入壁纸名称'
        return false
      }

      if (!form.cid) {
        this.confirmDialogText = '请选择壁纸分类'
        return false
      }

      // if (!form.contract && this.userInfoFresh.user_type === 0) {
      //   this.confirmDialogText = '请输入联系方式'
      //   return false
      // }

      if (form.wname.length > this.maxTextLength) {
        this.confirmDialogText = '壁纸名称最多支持15个字哦'
        return false
      }

      // if (this.tagsInput.length < 3) {
      //   this.confirmDialogText = '标签至少添加3个'
      //   return false
      // }

      // if (this.tagsInput.length > 10) {
      //   this.confirmDialogText = '标签最多支持10个'
      //   return false
      // }

      // if (this.hasTagLengthExceedsLimit) {
      //   this.confirmDialogText = '标签最多支持15个字哦'
      //   return false
      // }

      if (this.form.sub_wtype === 2) {
        console.log('sub_wtype', this.form.sub_wtype)
        const THEME_TAG = '主题'
        const tags = this.form.tags.split(',')
        console.log(tags, this.form.tags)
        const index = tags.indexOf(THEME_TAG)
        if (index === -1) {
          tags.push(THEME_TAG)
        }
        this.form.tags = tags.join(',')
      }

      if (this.form.tags.length === 0) {
        this.confirmDialogText = '请选择标签'
        return false
      }
      return true
    },
    handleConfirmDialogClose() {
      if (this.form.commit) {
        this.originateClient = false
      }

      this.confirmDialogText = ''
      this.confirmDialogConfirmText = '我知道了'
    },
    handleConfirmDialogConfirm() {
      if (this.confirmDialogConfirmText === '成为元气UP') {
        this.confirmDialogText = ''
        this.confirmDialogConfirmText = '我知道了'
        this.$router.push('/contract/author')
      }
    },
    onWallpaperUploadError(errorMsg) {
      this.confirmDialogText = errorMsg
    },
    async fetchFindTagList(query = '') {
      const res = await findTagList({
        kw: query,
        count: 20,
      })
      console.log('findTagList', res)
      if (res && res.data) {
        this.tagList = res.data
      }
    },
    async fetchPublish() {
      // 点击【发布】或刷新页面，需识别用户是否完成完成签署步骤
      // 没有签约资格 不报签约警告
      // if (!this.isContractCheck && this.contractCheck.status !== 0) {
      //   await this.fetchContractCheck()
      //   if (!this.isContractCheck) {
      //     this.contractCheckWarn = true
      //   }
      //   // 还未签约成功 不能提交
      //   // 刚刚签约成功 展示作品授权金额的填写框
      //   return
      // }
      if (!this.verification()) {
        return
      }

      try {
        const { form } = this
        const param = {
          common: this.common,
          wname: form.wname,
          cid: form.cid,
          contract: form.contract,
          paper_url: form.mobile_paper_url,
          resource_id: form.mobile_resource_id,
          preview_jpg: form.mobile_preview_jpg,
          ptype: form.ptype || 0,
          wtype: form.wtype,
          price: form.price,
          mobile_resource_format: form.mobile_resource_format,
        }
        const res = await doCommit(param, this.queryPlatform)
        if (res.resp_common && !res.resp_common.ret) {
          this.confirmDialogText
            = '发布成功，壁纸进入审核流程，<br/>审核结果将通过元气壁纸消息中心通知您哦'
          this.hasFormSubmitted = true
          this.checkedTagEl.forEach((val, key) => {
            val.state = !val.state
          })
          this.checkedTagEl.clear()
          this.initForm()
        }
      } catch (err) {
        if (err.resp_common) {
          if ([4911031, 4911024].includes(err.resp_common.ret)) {
            this.showUpAuthDialog = true
          } else {
            this.confirmDialogText = err.resp_common.msg
          }
          return
        }

        this.confirmDialogText = err.message
      }
    },
    async fetchCateList() {
      const res = await getComponentList({ composite_type: 1 })
      console.log('cateList', res)
      if (res && res.categories) {
        this.cateList = res.categories
      }
    },
    async fetchUserInfo() {
      if (!this.common.token) {
        this.userInfoFresh = {}
        return
      }
      try {
        const res = await fetchUserInfo({
          common: this.common,
        })
        console.log('fetchUserInfo', res)
        if (res && res.resp_common && !res.resp_common.ret) {
          this.userInfoFresh = res.user_info
        }
      } catch (err) {
        // TODO
      }
    },
    async fetchContractCheck() {
      // const res = await fetchContractCheck()
      // this.contractCheck = res.data
      // this.isContractCheck = res.data.status === 7 // 签约成功
    },
    fetchClientParams() {
      const { resourceId, resourceUrl, previewJpg, effectId, mobileCrop, previewJPGMobile, subWtype } = this
      if ((resourceId && resourceUrl && previewJpg) || (mobileCrop && previewJPGMobile) || subWtype) {
        this.originateClient = true
        this.uploadDisable = true // 阻止修改上传内容

        this.form.resource_id = parseInt(resourceId, 10) // 资源id
        this.form.wtype = 5 // 手机主题壁纸
        this.form.paper_url = resourceUrl // 壁纸URL
        this.form.preview_jpg = previewJpg // 预览图
        this.form.vip_effect_ids = effectId // 特效

        this.form.mobile_clip_area = mobileCrop // 移动端壁纸裁剪区域
        this.form.mobile_preview_jpg = previewJPGMobile // 预览图(移动端)
        this.form.mobile_resource_id = parseInt(resourceId, 10)
        this.form.mobile_paper_url = resourceUrl // 组件内部逻辑有值就显示成功上传
        this.form.resource_format = 'cwpz'
        this.form.mobile_resource_format = 'zip'
        this.form.sub_wtype = subWtype
        console.log('init form', this.form)
      }
    },
    async fetchCkey() {
      const data = await fetchCkey('wallpaper_live_tags')
      const tagMap = new Map()
      const unrepeatKeys = list => Array.from(new Set(list)).map((tag) => {
        const obj = { tag, state: false }
        tagMap.set(tag, obj)
        return obj
      })
      this.ckey = {
        reference: unrepeatKeys(data.reference.tags),
        categories: data.categories.reduce((prev, next) => {
          prev[next.cid] = unrepeatKeys(next.tags)
          return prev
        }, {}),
        contest: unrepeatKeys(data.contest.reduce((prev, next) => {
          const startTime = new Date(next.start_time)
          const endTime = new Date(next.end_time)
          const now = Date.now()
          if (startTime < now && now < endTime) {
            prev.push(next.tag)
          }
          return prev
        }, [])),
        tagMap,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tag-tips {
  position: absolute;
  top: 50px;
  right: 30px;
  color: #A5A5AE;
  font-size: 14px;
}
.tips-tag {
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 13px;
  color: #A5A5AE;
  font-size: 12px;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 8px;
  &:hover {
    border: 1px solid #F4C000;
    color: #03040A;
  }
  &.active {
    border: 1px solid #F4C000;
    background: #F4C000;
    color: #03040A;
  }
}
.tags-label {
  width: 90px;
  line-height: 30px;
  float: left;
}
.tags {
  width: calc(100% - 100px);
  float: left;
}
.platform-upload-wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 13px 0 15px;
  background: #FFFFFF;
  border-radius: 10px;
}

.upload-form {
  padding-bottom: 20px;
  .l {
    width: 678px;
    margin: 0 auto;
  }
  a {
    color: #E88E01;
  }
  .sub {
    color: #999;
    font-size: 12px;
  }
}

.upload-form-for-mobile {
  .l {
    width: 678px;
  }
}

.upload-form-for-all {
  flex-wrap: wrap;
  .l, .r {
    width: 678px;
    margin: 0 auto;
  }
}

.all-platform-wrapper {
  display: flex;
}
.r {
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 0 auto;
  width: 678px;
  padding-top: 15px;
  label {
    display: block;
    margin: 10px 0 10px;
    font-size: 16px;
    color: #333;
  }
  .poster-label {
    margin: 0;
    &::after {
      content: '';
      display: table;
      clear: both;
    }
    .txt {
      float: left;
      margin-top: 5px;
    }
    .btn-poster-upload {
      float: right;
    }
  }
}
.one-row {
  /** 整行 */
  grid-column: 1 / 3;
}
.row {
  position: relative;
  margin-bottom: 10px;
  .el-radio,
  .el-checkbox {
    text-align: left;
  }
  &:nth-child(1) {
    margin-right: 20px;
  }
  .hl {
    font-style: normal;
    color: #f41c83;
  }
  .error {
    font-style: normal;
    font-size: 12px;
    color: #f41c83;
  }
  label {
    position: relative;
    .hl {
      position: absolute;
      left: -12px;
      top: 3px;
    }
  }
  ::v-deep {
    .el-radio {
      display: inline-block;
      margin-right: 30px;
    }
  }
}

.ctrl {
  padding-top: 28px;
  text-align: left;
  .btn-publish {
    display: inline-block;
    width: 240px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background: #f5b903;
    border-radius: 8px;
    color: #333;
    cursor: pointer;
  }
}

.confirm {
  // text-align: center;
  font-size: 12px;
  label {
    display: inline-block;
  }
  a {
    margin-left: 5px;
    text-decoration: underline;
    color: #E88E01;
  }
}

.el-select {
  display: block;
}
.flex {
  display: flex;
}
.upload-area {
  margin: 20px 0;
}
.select {
  position: relative;
  height: 28px;
  display:inline-block;
  .hl {
    font-style: normal;
    color: #f41c83;
    position: absolute;
    left: -12px;
    top: 3px;
  }
  .input-select {
    position: relative;
    display: inline-block;
    width: 68px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    border: 1px solid #F8D874;
    border-radius: 4px;
    &:hover {
      .dropdown {
        display: block;
      }
    }
    &.select-image{
      width: 88px;
      &::before {
        content: '';
        position: absolute;
        right: 6px;
        top: 9px;
        width: 0;
        height: 0;
        border-width: 6px;
        border-style: solid;
        border-color: #333 transparent transparent transparent;
      }
    }

    span {
      display: block;
      padding: 0 10px;
      cursor: pointer;
    }
    .dropdown {
      z-index: 5;
      display: none;
      position: absolute;
      left: 0;
      top: 25px;
      padding-top: 5px;
      ul {
        width: 110px;
        // height: 60px;
        background: #fff;
        border: 1px solid #A1A1A1;
        border-radius: 4px;
      }
      li {
        padding: 0 10px;
        line-height: 28px;
        cursor: pointer;
      }
    }
  }
}
.lm {
  display: flex;
  flex-direction: row;
}
.yuanbao-tips {
  display: inline-block;
  font-size: 12px;
  color: #e88e01;
  cursor: pointer;
  .icon-qa {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-style: normal;
    background: #e7e7e7;
    border-radius: 50%;
    color: #333;
  }
}
.rule-wrap {
  z-index: 8;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.mask {
  z-index: 7;
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
}
.hezuo {
  display: flex;
  align-content: center;
  .input {
    font-size: 14px;
  }
}
.know-more {
  cursor: pointer;
  text-decoration: underline;
  color: #E88E01;
}
.is-theme {
  margin-left: 10px;
  font-size: 14px;
  color: red;
}
</style>
